import React from 'react';
import { compose } from 'redux';

import __DEPRECATED_defineResources from 'dpl/shared/fetching/deprecated/defineResources';
import {
  statesResourceDefinition,
  paymentRequestBuyerProfileResourceDefinition
} from 'dpl/shared/utils/tptConnectResourceDefinitions';
import { CONSTRAINT_TYPES } from 'dpl/shared/validations/constraints';
import withCurrentUser from 'dpl/decorators/withCurrentUser';
import withFormCapabilities from 'dpl/form/decorators/withFormCapabilities';
import StripeChargeModalAccountDataStep from 'dpl/components/StripeCharge/New/StripeChargeModal/StripeChargeModalAccountDataStep';
import StripeChargeModalAccountDataStepV2 from 'dpl/components/StripeCharge/New/StripeChargeModal/StripeChargeModalAccountDataStepV2';
import { sendAnalyticsIdentify } from 'dpl/util/analytics';
import isFeatureEnabled from 'dpl/util/isFeatureEnabled';
import { FEATURES } from 'dpl/shared/constants/features';

const IS_REL_PAYMENT_REQUEST_STEPS_V2_ENABLED = isFeatureEnabled(
  FEATURES.REL_PAYMENT_REQUEST_STEPS_V2
);

function StripeChargeModalAccountDataStepContainer(props) {
  return IS_REL_PAYMENT_REQUEST_STEPS_V2_ENABLED ? (
    <StripeChargeModalAccountDataStepV2 {...props} />
  ) : (
    <StripeChargeModalAccountDataStep {...props} />
  );
}

export default compose(
  withCurrentUser,
  __DEPRECATED_defineResources((_, { currentUser, isLoggedIn }) => ({
    buyerProfileData: paymentRequestBuyerProfileResourceDefinition(
      isLoggedIn && currentUser.value.data.buyer_profile_id
    ),
    availableStatesData: statesResourceDefinition
  })),
  withFormCapabilities(
    ({ buyerProfileData }) => buyerProfileData.value.buyer_profile,
    {
      onSubmit: ({ buyerProfileData, currentUser }, formStateForSubmission) =>
        buyerProfileData.create(formStateForSubmission).then(buyerProfile => {
          sendAnalyticsIdentify({
            userId: buyerProfile.data.buyer_profile.user_attributes.id
          });
          return currentUser.fetch().then(() => {
            return buyerProfile;
          });
        }),
      mapPropsAndStateToValidationSchema: ({ buyerProfileData }) => {
        let baseValidations = {};

        if (!buyerProfileData.value.buyer_profile.user_attributes.claimed) {
          baseValidations = {
            ...baseValidations,
            user_attributes: {
              first_name: CONSTRAINT_TYPES.NON_EMPTY,
              last_name: CONSTRAINT_TYPES.TEXT
            }
          };
        }

        if (!buyerProfileData.value.buyer_profile.user_attributes.id) {
          baseValidations = {
            ...baseValidations,
            user_attributes: {
              ...baseValidations.user_attributes,
              email: CONSTRAINT_TYPES.EMAIL_VALID
            }
          };
        }

        return baseValidations;
      }
    }
  )
)(StripeChargeModalAccountDataStepContainer);
